export default {
  CUSTOMER_API:"https://customer.api.drift.com",
  CONVERSATION_API: "https://conversation.api.drift.com",
  ACCOUNTS_API: "https://account.api.drift.com",
  PAGES_HOST: "drift.click",
  WS_API: "https://ws.api.drift.com",
  WS: "wss://ws.api.drift.com",
  SALES_INBOX_ID: 44,
  SALES_USER_ID: 46894,
  CUSTOMER_WEB_URL: "https://app.drift.com",
  LETS_GO_URL: "https://app.drift.com",
  WELCOME_WEB_URL: "https://app.drift.com/welcome",
  START_WEB_URL: "https://start.drift.com",
  DEFAULT_CLIENT_ID: "1UDhLV0zBBVZo3",
  GOOGLE_CLIENT_ID: "87492603950-u124kma19e32jh963uc9s3vsuujpm53k.apps.googleusercontent.com",
  MICROSOFT_CALENDAR_CLIENT_ID: "57aa99b9-8cd2-4c0e-9498-2d6749d33f3b",
  CLIENT_ID: "5ud8gidk3rp7du",
  CLIENT_ID_REDIRECT_URI: "https://app.drift.com",
  ONE_TIME_TOKEN: "driftt",
  ONBOARDING_URL: "https://app.drift.com/letsgo",
  SENTRY_ID: "https://af5b94f0cb4f4b21ac8ba242fde9f7e2@sentry.io/1311407",
  SEGMENT_ID: "YXwH8WAoOobo2Fa0YwXM5a1Ag09H7LXX",
  SAML_CLIENT_ID: "adMFuOx4OVWsZa",
  SPLIT_ID: "sgqrbfcfvcomh9u28tb74rbp8ioriq1hi9em",
  EMBED_ID: "x2akzxwz6gun",
  PROFILES_WEB_URL: "https://drift.me/",
  MARKETO_ID: "021-KUC-974",
  MICROSOFT_OAUTH_BASE_URL: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
  INTERACTION_ID: 54308,
  DRIFT_VIDEO_URL: "https://video.drift.com",
  DRIFT_VIDEO_INVITE_REDIRECT_URL: "https://video.drift.com/accounts/invite-redirect",
  DRIFT_VIDEO_HOMEPAGE: "https://video.drift.com",
  DRIFT_VIDEO_EXTENSION_URL: "https://chrome.google.com/webstore/detail/drift-video/kfhkikpdmehlpkaiplafjkaicdljldcf?hl=en",
  DRIFT_VIDEO_EXTENSION_ID: "kfhkikpdmehlpkaiplafjkaicdljldcf",
  WEB_PUSH_SERVER_PUBLIC_KEY: "BNcmBXOKZwIABd72e1H_DG1tyKMf6P4wKH7q8qkjMpHe6JIODFIn0mPOeT9Tq94WiABYq2818rFGKiiWExKJtWA=",
  CAPTCHA_SITE_KEY: "6LeMEKwZAAAAAIBvZaRdxw4b7Mzrfcgy1kGERpyc"
}
